import { store } from '@/store'
import findGoalCollections from '@/composables/goalCollections/findGoalCollections'
import { getCollectionColor } from '@/composables/goalCollections/utils'

const getFrameworkSubCategories = async (frameworkId) => {
  // get categories
  const response = await store.dispatch('categories/find', {
    query: {
      frameworkId,
    },
  })
  const categories = response.data
  // get sub-categories
  const subCategoriesResponse = await store.dispatch('sub-categories/find', {
    query: {
      categoryId: { $in: categories.map(category => category.id) },
      isRequired: false,
    },
  })
  const subCategories = subCategoriesResponse.data.map(subCategory => {
    return {
      ...subCategory,
      goals: [],
      frameworkId: frameworkId,
    }
  })
  return subCategories
}

const findGoalCollectionsSubCategories = async (goalCollections) => {
  const goalCollectionsSubCategories = await store.dispatch('goal-collections-sub-categories/find', {
    query: {
      goalCollectionId: { $in: goalCollections.map(goalCollection => goalCollection.id) },
    },
  })
  return goalCollectionsSubCategories.data
}

const getCollectionTitle = (goalCollectionId, collections) => {
  const collection = collections.find(collection => collection.id === goalCollectionId)
  return collection ? collection.title : null
}

export default async function getSubCategoriesWithGoals (frameworkId) {
  const subCategories = await getFrameworkSubCategories(frameworkId)
  const goalCollections = await findGoalCollections(null, frameworkId, 'getSubCategoriesWithGoals')
  const goalCollectionsSubCategories = await findGoalCollectionsSubCategories(goalCollections)
  return subCategories.map(subCategory => {
    const goals = goalCollectionsSubCategories
      .filter(g => g.subCategoryId === subCategory.id && g.isEnabled)
      .map(g => ({
        ...g,
        goalCollectionTitle: getCollectionTitle(g.goalCollectionId, goalCollections),
        goalCollectionColor: getCollectionColor(g.goalCollectionId),
      }))
      .sort((a, b) => a.goalCollectionId - b.goalCollectionId)

    return {
      ...subCategory,
      goals: goals,
      frameworkId: frameworkId,
    }
  })
}
